import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Icon from "../../Icon";
import Modal from "../../Modal";
import { modal, modalData } from "./../redux/modalSlice";
import styles from "./Modal.module.sass";
import { login, loginData } from "../../../screens/SignIn/redux/loginSlice";
import axios from "axios";
import { getPdf } from "./../../../features/getPdf";
const App = ({ className }) => {
  const dispatch = useDispatch();

  const modaldata = useSelector(modalData);

  //const logindata = useSelector(loginData);
  const logindata = JSON.parse(window.sessionStorage.getItem("logindata") !== null ? window.sessionStorage.getItem("logindata") : "{}");

  return (
    <Modal
      outerClassName={styles.outerZaznamProblemu}
      visible={modaldata.ZobrazHtml2}
    >
      <div className={styles.ico_Title}>
        <button
          onClick={ () => {
            dispatch(modal({ data: { ...modaldata, ZobrazHtml2: false } }));
          }}
        >
          <Icon name="close" size="20" />
        </button>
      </div>

      <div
        className={styles.ZobrazHtml}
        dangerouslySetInnerHTML={{ __html: modaldata.Html2Data }}
      />
    </Modal>
  );
};
export default App;
